import React from 'react';
import _ from 'lodash';
import getCroppingQueryParams from '../../util/getCroppingQueryParams';
import publicUrls from '../../config/publicUrls';
import getArticleLink from '../../util/getArticleLink';

/*
 Used to show nicer article previews in google search feed
 https://developers.google.com/search/docs/data-types/articles
 Can be tested here: https://search.google.com/structured-data/testing-tool
 The status of prod rich card can be checked here: https://www.google.com/webmasters/tools/rich-cards?hl=en&authuser=2&siteUrl=http://www.viasatsport.se/
*/
export default class GoogleArticleRichCard extends React.PureComponent {
  render() {
    const { article, country, isFirstArticle } = this.props;

    const logo = require(`../../../assets/viasport-logo-${country}.png`);

    const image = _.get(article, 'pictures[0].data.url')
      || _.get(article, 'videos[0].data.posterUrl');
    const imageJson = image &&
      `"image": {
        "@type": "ImageObject",
        "url": "${image + getCroppingQueryParams(5)}",
        "height": 563,
        "width": 1000
      },`;

    const author = _.get(article, 'authors[0].data.name');

    const mainEntity = isFirstArticle &&
      `"mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "${getArticleLink(article, { href: true })}"
      },`;

    const script = `
        <script type="application/ld+json">
          {
            "@context": "http://schema.org",
            "@type": "NewsArticle",
            ${mainEntity || ''}
            "headline": "${_.escape(article.title)}",
            "datePublished": "${new Date(article.createdTimestamp)}",
            "dateModified": "${new Date(article.updatedTimestamp)}",
            ${imageJson || ''}
            "author": {
              "@type": "Person",
              "name": "${author || '-'}"
            },
            "description": "${_.escape(article.preamble)}",
            "publisher": {
                "@type": "Organization",
                "name": "${publicUrls[country]}",
                "logo": {
                    "@type": "ImageObject",
                    "url": "${logo}"
                }
            }
          }
        </script>`;

    return <div dangerouslySetInnerHTML={{ __html: script }} />;
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/GoogleArticleRichCard.jsx